import React from 'react';

import DatePicker from 'react-datepicker';
import { Field } from 'react-final-form';

const FormDatePicker = ({
  label,
  required,
  placeholder,
  name,
  validate,
  dateFormat = 'YYYY-MM',
  includeDates,
  handleDateSelect,
}) => {
  return (
    <div className="form-field date-picker">
      <Field placeholder={placeholder} name={name} validate={validate}>
        {({ input, meta }) => (
          <div className={`form-group ${meta.error && meta.touched ? 'error' : ''}`}>
            <label htmlFor={`${name}`}>
              {label}
              <span className="required">{required ? '*' : ''}</span>
            </label>
            <DatePicker
              {...input}
              autoComplete="off"
              dateFormat={dateFormat}
              selected={input.value ? new Date(input.value) : null}
              includeDates={includeDates}
              onSelect={handleDateSelect}
            />
            {meta.error && meta.touched && <p className="error-text">{meta.error}</p>}
          </div>
        )}
      </Field>
    </div>
  );
};

export default FormDatePicker;
